import { i18n } from "../../i18n.js";
var hash = require("object-hash");
import { validateInput, computeCustomFormatLabel } from "../../helpers/helpers";

const state = {
  formats: {},
  quantities: []
};

const getters = {
  getCustomFormats: (state, getters, rootState, rootGetters) => {
    return state.formats[rootGetters.getActiveProductPartCode]
      ? state.formats[rootGetters.getActiveProductPartCode]
      : [];
  },
  getCustomQuantities: state => {
    return state.quantities;
  },
  getCustomQuantitiesLabels: (state, getters, rootState, rootGetters) => {
    return getters.getCustomQuantities.map(el => {
      return el.label;
    });
  },
  getInputQuantityMinMax: (state, getters, rootState, rootGetters) => {
    return {
      min: parseInt(rootGetters.getConfig.min_qty),
      max: parseInt(rootGetters.getConfig.max_qty)
    };
  },
  getLocalStorageName: (state, getters) => {
    return getters.getWebProductId + "_" + getters.getWebproductHashData; // + checksum or something from webproduct.data
  },
  getCustomFormatLimits: (state, getters, rootState, rootGetters) => {
    var activePPOptions = rootGetters.getActiveProductPageOptions;
    if (!activePPOptions.format) {
      return {};
    }

    var width_min = null;
    var width_max = null;
    var height_min = null;
    var height_max = null;

    var formats = [];

    for (var option of activePPOptions.format.values) {
      var width = parseFloat(option.attributes.width);
      var height = parseFloat(option.attributes.height);

      formats.push({
        width,
        height,
        name: option.value
      });

      if (width_min == null) {
        width_min = width;
        width_max = width;
        height_min = height;
        height_max = height;
      } else {
        if (width > width_max) {
          width_max = width;
        } else if (width < width_min) {
          width_min = width;
        }

        if (height > height_max) {
          height_max = height;
        } else if (height < height_min) {
          height_min = height;
        }
      }
    }

    // add also the current custom formats ... we need to compare with them also
    for (var format of getters.getCustomFormats) {
      formats.push({
        width: format.width,
        height: format.height,
        name: format.value
      });
    }
    return {
      formats,
      limits: {
        width_min,
        width_max,
        height_min,
        height_max
      }
    };
  }
};

const mutations = {
  setCustomQuantity: (state, { getters, payload }) => {
    const qty_exists = state.quantities.filter(el => {
      return el.qty == payload;
    });
    if (qty_exists.length > 0) {
      return;
    }
    state.quantities.push({
      label: "custom_qty_" + payload,
      qty: payload
    });
  },
  setCustomFormat: (state, { getters, payload }) => {
    var formatsPP = { ...state.formats };
    if (!formatsPP[getters.getActiveProductPartCode]) {
      formatsPP[getters.getActiveProductPartCode] = [];
    }
    formatsPP[getters.getActiveProductPartCode].push({
      label: computeCustomFormatLabel(
        getters.getMeasurementSystem,
        payload.width,
        payload.height
      ),
      value: "custom_" + payload.width + "_" + payload.height,
      width: payload.width,
      height: payload.height
    });
    state.formats = formatsPP;
  },
  setCustomFromLocalStorage: (state, { getters }) => {
    localStorage[getters.getLocalStorageName] = JSON.stringify(state);
  },
  loadCustomFromLocalStorage: (state, { getters, payload }) => {
    var localStorageKey = getters.getLocalStorageName;
    if (localStorage[localStorageKey]) {
      var newState = JSON.parse(localStorage[localStorageKey]);
      state.formats = newState.formats;
      state.quantities = newState.quantities;
    }
    if (getters.getIsCimpressProduct && getters.getQuantitySelection) {
      const qties = getters.getQuantitySelection.split(",");
      const custom_qties = qties
        .filter(elId => {
          return !getters.getCustomQuantitiesLabels.includes(
            "custom_qty_" + elId.trim()
          );
        })
        .map(el => {
          return {
            label: "custom_qty_" + el.trim(),
            qty: el.trim()
          };
        });
      state.quantities = [...state.quantities, ...custom_qties];
    }
  }
};

const actions = {
  setCustomQuantity: ({ commit, getters, dispatch }, payload) => {
    commit("setCustomQuantity", { getters, payload });
    dispatch("setQuantityCustom", {
      qty: payload,
      qtyCode: "custom_qty_" + payload
    });
    commit("setCustomFromLocalStorage", { getters });
  },
  setCustomFormat: ({ commit, getters, dispatch }, payload) => {
    commit("setCustomFormat", { getters, payload });
    dispatch("setPageOption", {
      optionType: "main",
      value: "custom_" + payload.width + "_" + payload.height,
      option: "format"
    });
    commit("setCustomFromLocalStorage", { getters });
  },
  loadCustomFromLocalStorage: ({ commit, getters }, payload) => {
    commit("loadCustomFromLocalStorage", { getters, payload });
  },
  inputCustomFormat: (context, { width, height, widget }) => {
    var formatLimits = context.getters.getCustomFormatLimits;
    var widthValid = validateInput(
      width.toString(),
      "Width",
      formatLimits.limits.width_min,
      formatLimits.limits.width_max
    );
    if (!widthValid.valid) {
      widget.$swal({ text: widthValid.msg, icon: "warning" });
      return;
    }
    var heightValid = validateInput(
      height.toString(),
      "Height",
      formatLimits.limits.height_min,
      formatLimits.limits.height_max
    );
    if (!heightValid.valid) {
      widget.$swal({ text: heightValid.msg, icon: "warning" });
      return;
    }

    // check if this format already exists
    for (var format of formatLimits.formats) {
      if (
        format.width === widthValid.number &&
        format.height === heightValid.number
      ) {
        context.dispatch("setPageOption", {
          optionType: "main",
          value: format.name,
          option: "format"
        });
        return;
      }
    }
    context.dispatch("setCustomFormat", {
      width: widthValid.number,
      height: heightValid.number
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
